import BrandsPage from 'src/dispensary/core-menu/brands';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

BrandsPage.layout = CoreMenuLayout;
export default BrandsPage;
